import settings from '@config/settings';
import {
  KovContentBlock,
  KovContentBlockProvider,
} from '@kathondvla/react-shared-components/src/components/contentBlock';
import { selectFullAnnotatedCurriculumViewModel } from '@store/curriculum/curriculumSelectors';
import { object } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import './richTextTab.scss';
import { trackReadRichTextTab } from '@store/tracking/trackingSagas';
import { useEffect } from 'react';

const RichTextTab = ({ tabName }) => {
  const tabInfo = useSelector((state) => selectFullAnnotatedCurriculumViewModel(state)?.[tabName]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(trackReadRichTextTab(tabName));
  }, [tabName, dispatch]);

  return (
    <div className="rich-text-tab">
      <KovContentBlockProvider baseUrl={settings.apisAndUrls.api} allTitlesH1={false}>
        <KovContentBlock item={tabInfo} />
      </KovContentBlockProvider>
    </div>
  );
};

RichTextTab.propTypes = {
  tabInfo: object,
};

export default RichTextTab;
